import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Image } from 'react-bootstrap';
import { get } from "lodash";
import i18n from 'Common/i18n';
import { languages } from 'Common/data/languages';

const TopBar = () => {
    const [selectlanguage, setSelectlanguage] = useState('');

    useEffect(() => {
        const currentlanguage: any = localStorage.getItem('I18NLANGUAGE') || 'en';
        setSelectlanguage(currentlanguage);
        i18n.changeLanguage(currentlanguage);
    }, []);

    return (
        <React.Fragment>
            <div className="top-tagbar">
                <Container fluid>
                    <Row className="justify-content-between align-items-center">
                        <Col md={4} xs={9} className='ps-0'>
                            <div className="fs-14 fw-medium">
                                <i className="bi bi-geo-alt align-middle me-2"></i> Kanjirappally, Kottayam
                            </div>
                        </Col>

                        <Col md={4} xs={6} className="d-none d-xxl-block">
                            <div className="d-flex align-items-center justify-content-center gap-3 fs-14 fw-medium">
                                <div>
                                    <i className="bi bi-envelope align-middle me-2"></i> info@fionaziya.com
                                </div>
                            </div>
                        </Col>

                        <Col md={4} xs={3}>
                            <div className="d-flex align-items-center justify-content-end gap-3 fs-14">
                                <div className='text-reset fw-normal d-none d-lg-block'>
                                    <i className='bi bi-telephone-outbound align-middle me-2'></i> +91 70348 95342, +91 97787 59369
                                </div>

                                <hr className="vr d-none d-lg-block" />

                                <div className="topbar-head-dropdown topbar-tag-dropdown justify-content-end">
                                    <div className="btn btn-icon btn-topbar rounded-circle text-reset fs-14 bg-transparent border-0 arrow-none d-flex align-items-center">
                                        <Image
                                            id="header-lang-img"
                                            src={get(languages, `${selectlanguage}.icon`)}
                                            alt="Header Language"
                                            height="16"
                                            className="me-2"
                                            roundedCircle
                                        />
                                        <span id="lang-name">
                                            {get(languages, `${selectlanguage}.lable`)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default TopBar;